<template>
  <div class="">
    <card>
      <template v-slot:header>
        <small class="badge badge-warning Rounded text-dark ml-2">{{ rows.length }}</small>
        <h4 class="d-inline">کارتابل انتظار قـــراردادها</h4>
        <hr />
      </template>
      <template v-slot:content>
        <bnp-grid v-if="$store.state.renderComponentCard" :hasRowNum="false" :propsColumn="Column" :propsRows="rows" :action="true">
          <template slot="action-slot" slot-scope="props">
            <a href="javascript:;" class="mr-2 badge" @click="OnApproval(props.props)" v-if="$session.get('Menu').filter((x) => x.RouteName == 'CartableContract')[0].isMojaz == 1" data-title="تایید قرارداد">
              <h6><span class="fas fa-certificate text-secondary hover-warning"></span></h6>
            </a>
            <a href="javascript:;" class="mr-2 badge" @click="OnDetailProduct(props.props)" data-title="محصولات"
              ><h6><span class="fad fa-info-circle hover-info"></span></h6
            ></a>
            <a href="javascript:;" class="mr-2 badge" @click="OnDeleteProduct(props.props)" data-title="حذف"
              ><h6><span class="fad fa-trash hover-danger"></span></h6
            ></a>
          </template>
          <template slot="TotallAmount" slot-scope="props">
            <span>{{ $Comma3ragham(props.props.TotallAmount) }}</span>
          </template>
          <template slot="Amount" slot-scope="props">
            <span>{{ $Comma3ragham(props.props.Amount) }}</span>
          </template>
          <template slot="Discount" slot-scope="props">
            <span>{{ $Comma3ragham(props.props.Discount) }}</span>
          </template>

          <template slot="Tax" slot-scope="props">
            <span>{{ $Comma3ragham(Number(props.props.Toll) + Number(props.props.Tax)) }}</span>
          </template>
          <template slot="CustomerCode" slot-scope="props">
            <span class="Pointer" @click="$FindeCustomerById('DetailCustomer',props.props.TblCustomerId,9,$event)" 
            @click.middle="$FindeCustomerById('DetailCustomer',props.props.TblCustomerId,9,$event)"   :title="props.props.CustomerName">{{ props.props.CustomerCode }}
              
            </span>
          </template>
        </bnp-grid>
      </template>
    </card>
    <modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
      <template v-slot:body>
        <!-- <detail-contract v-if="renderDetail" :Status="'Product'" :TblContract="cartabledetail" :IsCartableContract="true"></detail-contract> -->
        <cartable-contract-modal v-if="renderDetail" :Status="'Product'" :TblContract="cartabledetail" :IsCartableContract="true"></cartable-contract-modal>
      </template>
    </modal>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Modal from '../../Modal/Modal.vue'
import CartableContractModal from './CartableContractModal.vue'

export default {
  components: { Card, BnpGrid, Modal, CartableContractModal },
  data() {
    return {
      renderDetail: true,
      cartabledetail: {},
      DataAxoisCol: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmContract',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      Column: [],
      rows: [],
    }
  },
  methods: {
    GetColumns() {
      this.$GetColumns(this.DataAxoisCol, true)
        .then((data) => {
          this.Column = data
          this.Column.push({ id: 2416, name: 'CustomerName', visibility: false, label: 'نام مشتری' }, { id: 2416, name: 'tblComboGrpId12ContractType', visibility: true, label: 'نوع قرارداد' })
        })
        .finally(() => {
          this.$store.state.renderComponentCard = false
          this.$nextTick(() => {
            this.$store.state.renderComponentCard = true
          })
        })
    },
    GetRow() {
      let DataAxios_Get = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Contract/CartableContract',
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxios_Get)
        .then((data) => {
          this.rows = data
        })
        .finally(() => {
          this.$store.state.renderComponentCard = false
          this.$nextTick(() => {
            this.$store.state.renderComponentCard = true
          })
        })
    },
    OnDetailProduct(row) {
      this.cartabledetail = row
      this.renderDetail = false
      this.$nextTick(() => {
        this.renderDetail = true
        this.$store.state.Modal = true
      })
      // this.$router.push({ name: 'DetailContract', params: { Status: 'Product', TblContract: row, IsCartableContract: true } })
    },
    OnDeleteProduct(row) {
      this.$SweetQustion('عملیات حذف', 'از حذف قرارداد انتخابی اطمینان دارید؟؟', 'warning', 'حذف  قرارداد', 'انصراف', row, this.Delete, this.Cancel)
     
    },
    Delete(row){
      this.$store.state.OldDataForLog=JSON.stringify(row)
      let DataAxios_DeleteData = {
        ArryfildValue: row,
        Method: 'delete',
        Action: 'Contract',
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxios_DeleteData)
        .then((data) => {
          if (data.status == 'Ok') {
            this.$SetLog(row, 1, 0)
            this.GetRow()
            this.$toasted.success(' قرارداد با موفقیت حذف گردید ' , {duration:2000})

          } else {
            if (data.eNum == 547) {
              this.$mySweetDefaultTost('عملیات ناموفق', 'امکان حذف قرارداد وجود ندارد ، قرارداد شما داری محصول می باشد. ابتدا محصولات قرارداد رو حذف نمایید', 'warning', 5000)
            }
          }
        })
        .finally(() => {
          this.$store.state.renderComponentCard = false
          this.$nextTick(() => {
            this.$store.state.renderComponentCard = true
          })
        })
    },
    Cancel(){
      
    },
    OnApproval(row) {
      this.$SweetQustion('تایید قرارداد', 'از تایید قرارداد انتخابی اطمینان دارید؟؟', 'warning', 'تایید  قرارداد', 'انصراف', row, this.Success, this.Cancel)
    },
    Success(row){
      this.$store.state.OldDataForLog=JSON.stringify(row)
      let DataAxios_DeleteData = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Contract/ApprovalCartableContract',
        Token: this.$session.get('Token'),
      }
      DataAxios_DeleteData.ArryfildValue={tblUserIdEdit:this.$session.get("UserInfo").tblUserId ,Id:row.Id}
      this.$PostData(DataAxios_DeleteData)
        .then((data) => {
          if (data.status == 'Ok') {
            // this.$mySweetDefaultTost('عملیات موفق', 'مجوز این قرارداده اعمال شد', 'success', 2000)
            row.IsApproval=true;
            this.$SetLog(row, 0, 1)
            this.GetRow()
            this.$toasted.success(' مجوز قرارداد اعمال گردید ' , {duration:2000})
            this.$store.state.renderComponentCard = false
            this.$nextTick(() => {
              this.$store.state.renderComponentCard = true
            })
          } else {
            if (data.eNum == 547) {
              this.$mySweetDefaultTost('عملیات ناموفق', 'امکان ثبت قرارداد وجود ندارد ، قرارداد شما داری محصول می باشد. ابتدا محصولات قرارداد رو حذف نمایید', 'warning', 5000)
            }
            // console.log(data)
          }
        })
        .finally(() => {})
    },
    Cancel(){},
    // GotoCustomer(row) {
    //   // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: row.TblCustomerId, activeTab: 9 } })
    //   this.$FindeCustomerById('DetailCustomer',row.TblCustomerId,9,null)
    // },
  },
  mounted() {
    this.GetColumns()
    this.GetRow()
  },
}
</script>
<style scoped></style>
